import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { useMutation } from '@apollo/client';

import { bookingShape, historyShape } from 'constants/propTypes';
import { CANCEL_BOOKING } from 'store/mutations';
import { ActionButton } from 'components/ui/Button';
import { getBookingSearchURL, getClubEurostarSubscriptionURL, getHomeUrl } from 'utils/urls';

import NewSearchButton from './NewSearchButton';
import BookingPathRoutes from './BookingPathRoutes';
import ExpiryTimestamp from './ExpiryTimestamp';
import { StyledPage, InfoContainer, ActionContainer } from './BookingPath.styles';

const BookingPath = (props) => {
  const {
    reference,
    booking,
    canAddSpecialAssistanceToBooking,
    history: {
      push,
      location: { state, search }
    },
    booking: { expiryTimestamp },
    intl: { formatMessage },
    location: { pathname },
    refetch
  } = props;

  const [handleCancelBooking] = useMutation(CANCEL_BOOKING);

  useEffect(() => {
    const { location: prevLocation } = props;
    // eslint-disable-next-line no-restricted-globals
    if (location !== prevLocation && location.pathname.indexOf('/payment') > -1) {
      refetch({ reference });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location]);

  const membershipNumber = new URLSearchParams(search).get('membershipNumber');
  const isSubscription = new URLSearchParams(search).get('isSubscription') === 'true';

  const handleNewSearch = () => {
    handleCancelBooking({ variables: { bookingReference: reference } });

    const path = state?.isHotelOnly
      ? getHomeUrl()
      : isSubscription
      ? getClubEurostarSubscriptionURL(membershipNumber, reference)
      : getBookingSearchURL(membershipNumber);

    push(path, isSubscription ? { shouldRetry: true } : undefined);
  };

  return (
    <StyledPage>
      <InfoContainer>
        <ActionContainer>
          {pathname === `/booking/${reference}/pax/contact` && (
            <ActionButton
              label={formatMessage({ id: 'paxForm.goBack' })}
              onClick={() => push(`/booking/${reference}/pax`, state)}
              space="horizontal"
              width={2}
            />
          )}
          <NewSearchButton onClick={handleNewSearch} isSubscription={isSubscription} />
        </ActionContainer>
        <ExpiryTimestamp expiryTimestamp={expiryTimestamp} />
      </InfoContainer>
      <BookingPathRoutes booking={booking} canAddSpecialAssistanceToBooking={canAddSpecialAssistanceToBooking} />
    </StyledPage>
  );
};

BookingPath.propTypes = {
  reference: PropTypes.string.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
  history: historyShape.isRequired,
  refetch: PropTypes.func.isRequired,
  booking: bookingShape,
  canAddSpecialAssistanceToBooking: PropTypes.bool.isRequired,
  intl: intlShape
};

export default injectIntl(BookingPath);
